<template>
  <div class="positionfixed">
    <Header ref="childComp" @paySuccess="handleLoginSuccess"></Header>
  <div class="pc_all FreeCreation">
    <loginWindow style="z-index: 999999" v-if="showLogin" @close="showLogin = false" @loginSuccess="handleLoginSuccess" ></loginWindow>
    <div class="pc_all_content">
      <!-- 导航部分 -->
      <div
        class="FreeCreationNav animate__animated animate__fadeInDown"
        style="animation-delay: 0.2s"
      >
        <div class="FreeCreationNav_btn">
          <router-link to="/ailogo/FreeCreation/FreeCreation" class="FreeCreationNav_list font20 active">
            <span class="iconfont icon-chuangzuozhezhongxin"></span>自由创作
          </router-link>
          <router-link to="/ailogo/LetterLogo/LetterLogo" class="FreeCreationNav_list font20">
            <span class="iconfont icon-fa-buysellads"></span>字母LOGO
          </router-link>
          <router-link to="/ailogo/SameCreation/SameCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-AItongkuan"></span>同款创作
          </router-link>
        </div>
      </div>

      <div class="Keyword">
        <div class="KeywordTop">
          <div class="KeywordTop_left">
            <div
              class="KeywordTop_title active font20 animate__animated animate__fadeInDown"
              style="animation-delay: 0.4s"
            >
              <input
                  type="text"
                  placeholder="请用一句话描述您是做什么业务的？例如：我是做儿童画画培训班的"
                  v-model="business"
                  @input="updateBusiness"
              />
            </div>
            <div
              class="KeywordTop_left_content animate__animated animate__fadeInDown"
              style="animation-delay: 0.6s"
            >
              <textarea
                v-model="inputText"
                :placeholder="placeholder"
                class="font16"
                @input="updateCharCount"
                maxlength="150"
              ></textarea>
              <div class="left_content_btn font16">
                <div class="content_btn_lists font16">{{ charCount }}</div>
                /
                <div class="content_btn_list font16">150</div>
                <div class="content_btn_icon"></div>
                <div class="content_btn_right font16" @click="clearInput">
                  <span class="iconfont icon-a-qingkong1"></span>清空
                </div>
              </div>
            </div>

            <div
              :class="['KeywordAI  animate__animated animate__fadeInDown', { active: isActive }]"
              style="animation-delay: 0.8s"
            >
              <div class="KeywordAI_top">
                <div class="KeywordAI_top_btn" @click="handleKeywordAIButtonClick">
                  <img alt="" src="@a/ailogo/images/bn5.png" />
                  <span class="top_btn_title1">AI继续生成</span>
                  <span class="top_btn_title2">AILOGO智能关键词生成中...</span>
                  <div class="la-pacman la-1x">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div class="KeywordAI_top_title font16">
                  我们为您生成"{{ brandTitle }}"的LOGO创作优质关键词参考
                </div>
              </div>

              <div class="KeywordAI_bottom">
                <div class="KeywordAI_bottom_list">
                  <div class="bottom_list_title font16">
                    logo元素<span class="font16">(建议选1-3个)</span>
                  </div>
                  <div class="bottom_list_txt">
                  <span
                      v-for="item in logoItems"
                      :key="item"
                      :class="['list_txt_li', { selected: selectedItems.includes(item) }]"
                      @click="selectItem(item)"
                  >{{ item }}</span>
                  </div>
                </div>

                <div class="KeywordAI_bottom_list">
                  <div class="bottom_list_title font16">
                    品牌情绪化<span class="font16">(建议选1个)</span>
                  </div>
                  <div class="bottom_list_txt">
                  <span
                      v-for="item in emotionItems"
                      :key="item"
                      :class="['list_txt_li', { selected: selectedItems.includes(item) }]"
                      @click="selectItem(item)"
                  >{{ item }}</span>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div class="KeywordTop_right">
            <div
              class="KeywordTop_title font20 animate__animated animate__fadeInDown" style="animation-delay: 0.2s">
              示例LOGO
            </div>
            <div
              class="KeywordTop_right_content animate__animated animate__fadeInDown"
              style="animation-delay: 0.6s"
            >
              <div class="right_content_list">
                <div class="content_list_img"><img alt="" src="@a/ailogo/images/bn15.png" /></div>
                <div class="content_list_title font16">面包，小麦，美味的</div>
              </div>
              <div class="right_content_list">
                <div class="content_list_img"><img alt="" src="@a/ailogo/images/bn16.png" /></div>
                <div class="content_list_title font16">龙虾，禾苗，自然的</div>
              </div>
              <div class="right_content_list">
                <div class="content_list_img"><img alt="" src="@a/ailogo/images/bn17.png" /></div>
                <div class="content_list_title font16">茶壶，茶叶，现代的</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 按钮部分 -->
      <div class="Btn animate__animated animate__fadeInDown" style="animation-delay: 1s">
        <div class="Btn_prev font20" @click="goBack">
          <span class="iconfont icon-xiangyou"></span>上一步
        </div>
        <div
            :class="['Btn_next', { active: inputText.length > 0 }]"
            class="font20 form_btn_po"
            @click="generateLogo"
        >
        <div class="form_btn_po">生成<span class="iconfont icon-xiangyou"></span></div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@c/header/header'
import { mapState } from 'vuex'
import loginWindow from "@c/common/loginWindow/loginWindow";

export default {
  data() {
    return {

      showLogin: false,

      inputText: '',
      placeholder:
        '请输入您想在LOGO中看到的元素，建议输入3个及以上的关键 比如“龙游车行”可以输入: 跑车，龙，环形等...',
      logoItems: [],
      emotionItems: [],
      selectedItems: [],
      brandTitle: '',
      isActive: false,
      brandName: '',
      slogan: '',
      selectedIndustryId: '',
      selectedStyleId: '',
      selectedColorId: '',
      otherIndustry: '',
      otherColor: '',
      business: ''
    }
  },
  computed: {
    charCount() {
      return this.inputText.length
    },
    ...mapState({
      brandName: state => state.brand.name,
      slogan: state => state.brand.slogan,
      selectedIndustryId: state => state.selectedIndustryId,
      selectedStyleId: state => state.selectedStyleId,
      selectedColorId: state => state.selectedColorId,
      otherIndustry: state => state.otherIndustry,
      otherColor: state => state.otherColor
    })
  },
  components: {
    loginWindow,
    Header
  },
  created() {
    // 从 localStorage 加载数据
    this.loadFromLocalStorage();

    // 在页面创建时调用获取关键词的接口
    this.fetchLogoItems();
    this.brandTitle = this.brandName;
  },
  methods: {
    updateBusiness() {
      //将输入存储到 localStorage
      localStorage.setItem('logoBusiness', this.business);
    },
    updateCharCount() {
      if (this.inputText.length > 150) {
        this.inputText = this.inputText.slice(0, 150)
      }
    },
    clearInput() {
      this.inputText = ''
      this.selectedItems = []
    },
    async handleKeywordAIButtonClick() {
      // 显示加载状态
      this.isActive = true;

      // 调用 fetchLogoItems 请求数据
      await this.fetchLogoItems();

      // 隐藏加载状态
      this.isActive = false;
    },
    selectItem(item) {
      if (this.selectedItems.includes(item)) {
        // If the item is already selected, remove it
        this.selectedItems = this.selectedItems.filter((selected) => selected !== item)

        // Update inputText by removing the item
        const itemsArray = this.inputText.split(',').filter((text) => text.trim() !== item)
        this.inputText = itemsArray.join(',')
      } else {
        // If the item is not selected, add it
        if (this.inputText.length > 0) {
          this.inputText += `,${item}`
        } else {
          this.inputText = item
        }
        this.selectedItems.push(item)
      }
    },
    goBack() {
      this.$emit('decrease-progress')
      this.$router.back() // 或者使用 this.$router.go(-1) 返回前一个页面
    },

    async generateLogo() {

      try {

        console.log('是否登录', this.$store.getters.isLogin);
        if (!this.$store.getters.isLogin) {
          this.showLogin = true;
        }else{

          // Step 1: 先查询用户信息，判断是否有生成次数
          const userInfoRes = await this.axios.get('/api/member/getInfo');
          const userInfo = userInfoRes.result;

          // 将用户信息存入本地和 Vuex 中
          localStorage.setItem('memberInfo', JSON.stringify(userInfo));
          this.$store.commit('setMemberInfo', userInfo);

          // 判断是否有生成次数
          if (userInfo.logo_num <= 0) {
            // 如果没有次数，弹出充值窗口
            this.$message.error('您当前没有生成次数，请充值后再试。');
            // 设置一个变量用于控制充值弹窗的显示
            this.$refs.childComp.showWindow();
            return;
          }

          // Step 2: 准备生成 Logo 的参数
          const params = {
            title: this.brandName,
            subtitle: this.slogan,
            industry: {
              industryId: this.selectedIndustryId,
              industryName: this.otherIndustry
            },
            style: {
              styleId: this.selectedStyleId,
              styleName: ""
            },
            color: {
              colorId: this.selectedColorId,
              colorName: this.otherColor
            },
            keyword: this.inputText || "美丽,大,好看",
            business: this.business || ''
          };

          // Step 3: 调用生成接口
          const response = await this.axios.post('api/LogoChoice/freeCreate', params);
          if (response.code === 1) {
            console.log('生成成功:', response.msg);

            // 生成成功，刷新用户信息
            const updatedUserInfoRes = await this.axios.get('/api/member/getInfo');
            localStorage.setItem('memberInfo', JSON.stringify(updatedUserInfoRes.result));
            this.$store.commit('setMemberInfo', updatedUserInfoRes.result);

            // 跳转到指定页面
            this.$router.push('/ailogo/LogoCenter/FreeCreationCenter');
          } else {
            console.error('接口返回错误:', response.msg);
            //如果msg是 生成次数不足 则弹出充值窗口
            if (response.msg === '生成次数不足') {
              this.$message.error('您当前没有生成次数，请充值后再试。');
              this.$refs.childComp.showWindow();
            } else {
              this.$message.error('生成失败，请稍后再试。');
            }
          }

        }

      } catch (error) {
        console.error('请求接口时出错:', error);
        this.$message.error('网络错误，请检查连接');
      }
    },
    handleLoginSuccess() {
      // 登录成功后调用 generateLogo
      this.showLogin = false; // 隐藏登录窗口
      this.generateLogo();
    },
    async fetchLogoItems() {
      this.isActive = true; // 请求开始，显示加载提示

      try {
        // Step 1: 获取生成Logo的关键词
        const params = {
          title: this.brandName,
          subtitle: this.slogan,
          industry: {
            industryId: this.selectedIndustryId,
            industryName: this.otherIndustry
          },
          style: {
            styleId: this.selectedStyleId,
            styleName: ""
          },
          color: {
            colorId: this.selectedColorId,
            colorName: this.otherColor
          }
        };

        // Step 2: 使用 Promise.all 并行请求 logoKeywords 和 brandKeywords
        const [logoResponse, brandResponse] = await Promise.all([
          this.axios.post('api/LogoInfo/logoKeywords', params),
          this.axios.post('api/LogoInfo/brandKeywords', params)
        ]);

        // Step 3: 处理 logoKeywords 响应
        if (logoResponse.code === 1) {
          // 更新 logoItems
          this.logoItems = logoResponse.result.logoKeywords;
        } else {
          console.error('logoKeywords 接口返回错误:', logoResponse.msg);
          this.$message.error('获取 logoKeywords 失败，请稍后再试。');
        }

        // Step 4: 处理 brandKeywords 响应
        if (brandResponse.code === 1) {
          // 更新 emotionItems
          this.emotionItems = brandResponse.result.brandKeywords;
        } else {
          console.error('brandKeywords 接口返回错误:', brandResponse.msg);
          this.$message.error('获取 brandKeywords 失败，请稍后再试。');
        }

      } catch (error) {
        console.error('请求接口时出错:', error);
        this.$message.error('网络错误，请检查连接');
      } finally {
        this.isActive = false; // 请求完成后隐藏加载提示
      }
    },

    // 从 本地获取数据
    loadFromLocalStorage() {
      // 从 localStorage 中获取数据
      this.brandName = localStorage.getItem('logoBrandName');
      this.slogan = localStorage.getItem('logoSlogan');
      this.selectedIndustryId = localStorage.getItem('logoSelectedIndustryId');
      this.selectedStyleId = localStorage.getItem('logoSelectedStyleId');
      this.selectedColorId = localStorage.getItem('logoSelectedColorId');
      this.otherIndustry = localStorage.getItem('logoOtherIndustry');
      this.otherColor = localStorage.getItem('logoOtherColor');
      this.business = localStorage.getItem('logoBusiness');
    }


  },
  watch: {
    inputText(newText) {
      const currentItems = newText.split(',').filter((text) => text.trim() !== '')
      this.selectedItems = currentItems
    }
  }
}
</script>


<style>
@import "FreeCreation.css";
</style>
